module.exports = __webpack_public_path__ + "img/18_86.186bf02c.png";